'use client';

import { Providers } from 'src/app/providers';
import AuthLayout from 'src/components/Layout/AuthLayout';

// APX-480: auth group (login/signin/MFA/etc.) — one of the pilot surfaces for the
// static shell. These routes need the client-provider graph (AuthContext depends on
// the Redux Provider, sign-in views consume HeaderContext, AuthContext raises
// toasts), so the group mounts its own island unconditionally now that the APX-479
// split is permanent.
//
// This file previously carried `export const dynamic = 'force-dynamic'`. That was
// ALREADY INERT and removing it changes nothing: Next only reads route segment
// config from Server Components — see `collectAppPageSegments` in
// next/dist/build/segment-config/app/app-segments.js ("Only server components can
// have app segment configurations"). The directive that actually held this group
// dynamic was the one on the root layout. Same rule as the note in
// `src/app/global-error.tsx`; do not re-add it here.
export default function AuthGroupLayout({ children }: { children: React.ReactNode }) {
  return (
    <Providers>
      <AuthLayout>{children}</AuthLayout>
    </Providers>
  );
}
